import React from 'react'
import Switch from 'Components/Switch'

export default React.memo(props => {

  return (
    <Switch onChange={props.onChange}
            disabled={props.disabled || false}
            checked={(props.infoTiers && props.data !== undefined && (props.data.id === props.datas.find(b => b.libelle === '1' || b.libelle === 1 || b.libelle === true).id) || !props.infoTiers && (props.data === 1 || props.data === 1 || props.data === '1'))}
            label={props.title}/>
  )
})



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/Bool.js